const $faqs = $('.faq-item__question')

const fn = {
  init: () => {
    $faqs.on('click', fn.toggle)
  },

  toggle: (e) => {
    const $question = $(e.target).closest('.faq-item__question')
    const expanded = $question[0].getAttribute('aria-pressed') === 'true'

    $question[0].setAttribute('aria-pressed', expanded ? 'false' : 'true')
    $question.closest('.faq-item').toggleClass('is-active')
    $question.siblings('.faq-item__answer').slideToggle()

    if (expanded) {
      $question.find('.faq-item__indicator').text('+')
    } else {
      $question.find('.faq-item__indicator').text('-')
    }
  }
}

export default {
  can: () => $faqs.length,
  run: fn.init
}
